/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-warning-circle': {
    width: 12,
    height: 13,
    viewBox: '0 0 12 13',
    data: '<path pid="0" d="M6 .052a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm.75 7.745h-1.5v1.5h1.5v-1.5zM5 2.807l.506 4h.988L7 2.815l-2-.008z" _fill="#E25757" fill-rule="evenodd"/>'
  }
})
